<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <graph
        v-if="showStatistics"
        title="Cancelled Tickets"
        :has-data="true"
        :data-filter="true"
        :is-in-modal="true"
        :initial-date-range-option="1"
        :date-filter-options="[1, 2, 3, 4]"
        :max-date-range="21"
        @changeDateRange="changeDateRange($event)"
        @closeModal="$emit('closeModal')"
      >
        <line-chart
          v-if="totalRefundedTickets !== 0 && refundedTicketsChartData.labels.length > 1"
          :data="refundedTicketsChartData"
          :options="{}"
        />
        <div v-else class="noDataText">
          <div v-if="refundedTicketsChartData.labels.length === 1">
            Number of cancelled tickets for
            <b>
              {{ refundedTicketsChartData.labels[0] }}:
              {{ refundedTicketsChartData.datasets[0].data[0] }} </b
            >. <br />
            More data will be displayed tomorrow.
          </div>
          <div v-else>
            No data to display. Statistics will be available when there are cancelled tickets.
          </div>
        </div>
      </graph>
    </div>
  </div>
</template>

<script>
import Graph from '@/components/shared/graphs/graph.vue'
import { GET_REFUNDED_PURCHASES_BY_EVENT } from '@/graphql/purchase.graphql'
import LineChart from '@/components/shared/graphs/line-chart.vue'
import moment from 'moment/moment'

export default {
  name: 'refunded-tickets-modal',
  components: { LineChart, Graph },
  props: {
    eventId: String,
    eventTemplateId: String,
    eventTo: String,
    totalRefundedTickets: {
      type: Number,
      default: null,
    },
    orderItemId: {
      type: Number,
      default: null,
    },
    ticketSellerId: {
      type: Number,
      default: null,
    },
    promoCodeIds: {
      type: Array,
      default: null,
    },
    saleChannelOnline: Boolean,
  },

  data() {
    return {
      showStatistics: false,
      refundedTicketsChartData: null,
      startDate:
        moment(new Date()).startOf('day') > moment(this.eventTo).startOf('day')
          ? moment(this.eventTo).subtract(6, 'd').startOf('day').format('YYYY-MM-DD')
          : moment(new Date()).subtract(6, 'd').startOf('day').format('YYYY-MM-DD'),
      endDate:
        moment(new Date()).startOf('day') > moment(this.eventTo).startOf('day')
          ? moment(this.eventTo).startOf('day').format('YYYY-MM-DD')
          : moment(new Date()).startOf('day').format('YYYY-MM-DD'),
    }
  },
  apollo: {
    getRefundedPurchasesByEvent: {
      query: GET_REFUNDED_PURCHASES_BY_EVENT,
      variables() {
        return {
          eventId: this.eventId,
          eventTemplateId: this.eventTemplateId,
          orderItemId: this.orderItemId,
          ticketSellerId: this.ticketSellerId,
          promoCodeIds: this.promoCodeIds,
          saleChannelOnline: this.saleChannelOnline,
          startDate: this.startDate,
          endDate: this.endDate,
        }
      },
      manual: true,
      result({ data, loading }) {
        if (!loading && data) {
          const refundedTicketsData = data.getRefundedPurchasesByEvent

          this.refundedTicketsChartData = {
            labels: refundedTicketsData.map(entry => moment(entry.date).format('D/M')),
            datasets: [
              {
                title: 'Cancelled tickets',
                tooltipLabels: refundedTicketsData.map(
                  entry => `${moment(entry.date).format('D.M')}|${entry.totalRefunded}`,
                ),
                data: refundedTicketsData.map(entry => entry.totalRefunded),
              },
            ],
          }

          this.showStatistics = true
        }
      },
    },
  },

  methods: {
    modifyDateRangeIfEventPassed() {
      if (moment(this.startDate).startOf('day') > moment(this.eventTo).startOf('day')) {
        const dayDifference = moment(this.endDate).diff(moment(this.startDate), 'days')
        this.startDate = moment(this.eventTo).subtract(dayDifference, 'd').format('YYYY-MM-DD')
        this.endDate = moment(this.eventTo).endOf('day').format('YYYY-MM-DD')
      }
    },
    changeDateRange(dateRangeObject) {
      this.startDate = dateRangeObject.dateRange[0]
      this.endDate = dateRangeObject.dateRange[1]

      if (dateRangeObject.isCustom) {
        this.startDate = moment(this.startDate).format('YYYY-MM-DD')
        this.endDate = moment(this.endDate).format('YYYY-MM-DD')
      } else {
        this.modifyDateRangeIfEventPassed()
      }
      this.$apollo.queries.getRefundedPurchasesByEvent.refetch()
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  position: relative;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
</style>
